import React from 'react'
import { parse } from 'common-translations/src/vtj/html/Html.utils'

interface HtmlProps {
  html: string
}

const Html: React.FC<HtmlProps> = ({ html }) => {
  return <>{parse(html)}</>
}
export default Html
